import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from "@material-ui/core/InputAdornment";
import MaskedInput from "react-text-mask";

const styles = (theme) => ({
  fieldRoot: {},
  label: {
    color: theme.TextColor,
    transform: "translate(14px, 12px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
  },
  notchedOutline: {},
  inputRoot: {
    "& $notchedOutline,$inputMultiline": {
      padding: 0,
    },
    "&$inputDisabled": {
      padding: 0,
    },
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: `${theme.iconColor}`,
      },
  },
  inputRootWarning: {
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: theme.inputWarningLabelColor,
      },

    "& $notchedOutline, &$inputFocused $notchedOutline": {
      borderColor: theme.inputWarningLabelColor,
    },
  },
  inputFocused: {},
  inputDisabled: {},
  inputError: {},
  inputMultiline: {},
  inputField: {
    padding: 0,
    paddingLeft: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: 36,
  },
  numberInputWithoutIncrementer: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  iconClass: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  warningLabel: {
    color: theme.TextColor,
    transform: "translate(14px, 14px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
    "&$focusedLabel": {
      color: theme.inputWarningLabelColor,
    },
  },
  focusedLabel: {},
});

const CustomTextInput = (props) => {
  const { inputRef, mask, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      pipe={(value) => (value ? value.trim() : value)}
      guide={false}
    />
  );
};

const CustomTextField = ({
  classes,
  label,
  value,
  error,
  handleChange,
  showWarning,
  mask,
  hideIncrementer,
  ...other
}) => {
  const clearField = () => {
    handleChange("");
  };

  const skipSpecialCharForNumberInput = (e) =>
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

  const getFieldIcon = () => {
    if (value) {
      return (
        <InputAdornment>
          <Cancel onClick={clearField} classes={{ root: classes.iconClass }} />
        </InputAdornment>
      );
    }
    return null;
  };
  const inputComponent = mask ? { inputComponent: CustomTextInput } : {};
  return (
    <TextField
      autoComplete="off"
      classes={{
        root: classes.fieldRoot,
      }}
      InputLabelProps={{
        classes: {
          root: showWarning ? classes.warningLabel : classes.label,
          focused: classes.focusedLabel,
        },
      }}
      InputProps={{
        classes: {
          root: showWarning ? classes.inputRootWarning : classes.inputRoot,
          input: hideIncrementer
            ? classes.numberInputWithoutIncrementer
            : classes.inputField,
          notchedOutline: classes.notchedOutline,
          focused: classes.inputFocused,
          inputMultiline: `${classes.inputMultiline} customScroll`,
          disabled: classes.inputDisabled,
          error: classes.inputError,
        },
        endAdornment: getFieldIcon(),
        ...inputComponent,
        inputProps: { mask },
      }}
      value={value}
      onKeyDown={
        other.type === "number" ? skipSpecialCharForNumberInput : undefined
      } // when input type="number" , characters like '.','e','-' etc are not captured in onChange event.Therefore restrict them when key is pressed.
      onChange={(event) => handleChange(event.target.value)}
      margin="normal"
      variant="outlined"
      error={Boolean(error)}
      helperText={error}
      label={label}
      {...other}
    />
  );
};

export default withStyles(styles)(CustomTextField);
